import { render, staticRenderFns } from "./InstanceDetails.vue?vue&type=template&id=5165d600&scoped=true"
import script from "./InstanceDetails.vue?vue&type=script&lang=js"
export * from "./InstanceDetails.vue?vue&type=script&lang=js"
import style0 from "./InstanceDetails.vue?vue&type=style&index=0&id=5165d600&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5165d600",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5165d600')) {
      api.createRecord('5165d600', component.options)
    } else {
      api.reload('5165d600', component.options)
    }
    module.hot.accept("./InstanceDetails.vue?vue&type=template&id=5165d600&scoped=true", function () {
      api.rerender('5165d600', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/job/components/InstanceDetails.vue"
export default component.exports